/* FAYARD CUSTOM. Bandeau de cookies Shopify : apparition après un délai, logo, voile sur la page.
   On ne touche à aucun bouton ni à la logique de Shopify : seulement l'affichage. */
(function () {
  'use strict';

  var config = window.FayardConsent || {};
  var delay = typeof config.delay === 'number' ? config.delay : 3000;
  var start = Date.now();
  var backdrop = null;
  var timer = null;

  function banner() { return document.getElementById('shopify-pc__banner'); }
  function prefs() { return document.getElementById('shopify-pc__prefs'); }

  // Seul display compte : pendant le délai d'apparition, la carte est en visibility: hidden (animation CSS)
  // tout en étant bien ouverte ; tester visibility retirait le voile aussitôt posé.
  function isShown(el) {
    if (!el || !el.isConnected) return false;
    return getComputedStyle(el).display !== 'none';
  }

  function ensureBackdrop() {
    if (backdrop) return backdrop;
    backdrop = document.createElement('div');
    backdrop.className = 'fy-consent-backdrop';
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.appendChild(backdrop);
    return backdrop;
  }

  function decorate(el) {
    if (el.dataset.fyConsent) return;
    el.dataset.fyConsent = '1';
    var wrapper = el.querySelector('.shopify-pc__banner__wrapper');
    if (config.logo && wrapper) {
      var logo = document.createElement('div');
      logo.className = 'fy-consent-logo';
      var img = document.createElement('img');
      img.src = config.logo;
      img.alt = 'Maison Fayard';
      img.width = 180;
      img.height = 56;
      logo.appendChild(img);
      wrapper.insertBefore(logo, wrapper.firstChild);
    }
  }

  function reveal() {
    var el = banner();
    if (!el) return;
    decorate(el);
    ensureBackdrop();
    void el.offsetWidth; // fixe l'état de départ pour que la transition joue
    el.classList.add('fy-consent-show');
    document.documentElement.classList.add('fy-consent-open');
  }

  function sync() {
    var el = banner();
    var bannerOn = el && isShown(el) && el.classList.contains('fy-consent-show');
    var prefsOn = isShown(prefs());
    // Le voile reste tant que la carte ou la fenêtre des préférences est ouverte
    if (!bannerOn && !prefsOn) document.documentElement.classList.remove('fy-consent-open');
    else if (bannerOn) document.documentElement.classList.add('fy-consent-open');
  }

  function schedule() {
    var el = banner();
    if (!el || timer || el.classList.contains('fy-consent-show')) return;
    decorate(el);
    var wait = Math.max(0, delay - (Date.now() - start));
    timer = setTimeout(reveal, wait);
  }

  // Surveille seulement l'ajout d'éléments au <body>, puis les attributs du bandeau et des préférences
  var watched = [];
  var attrObserver = new MutationObserver(sync);
  function watch(el) {
    if (!el || watched.indexOf(el) !== -1) return;
    watched.push(el);
    attrObserver.observe(el, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  }

  var bodyObserver = new MutationObserver(function () {
    watch(banner());
    watch(prefs());
    schedule();
    sync();
  });

  function init() {
    bodyObserver.observe(document.body, { childList: true });
    watch(banner());
    watch(prefs());
    schedule();
  }

  if (document.body) init();
  else document.addEventListener('DOMContentLoaded', init);
})();
